import type { ComputedRef } from 'vue'
import type { Maybe, Setting, SettingCustomerAuthValue } from '@/types'

import { computed, nextTick, onMounted } from 'vue'

import { useCustomerSettingsStore } from '@/stores/customer/settings'

export const useCustomerAuthSettings = (header?: boolean) => {
  onMounted(() => {
    if (header) checkSettings()
  })

  const settingsStore = useCustomerSettingsStore()
  const accountSettings = computed(() =>
    settingsStore.getItemByName('customer_auth')
  ) as ComputedRef<Maybe<Setting<SettingCustomerAuthValue>>>

  async function checkSettings() {
    if (!accountSettings.value) {
      await settingsStore.fetchItemByName('customer_auth')
      await nextTick()
    }

    return accountSettings.value?.value.skip_order_auth
  }

  return { accountSettings, checkSettings }
}
